import { PopupType } from './types';

/**
 * 前端本地预校验错误枚举。
 * 文案通过 i18n_key 由 i18next 按当前语言加载，不再内联 zh/en/es 字符串。
 */
export const ClientError = {

    // ── 各扫描操作的固定 title（失败）────────────────────────────────────
    ARRIVAL_SCAN_TITLE: {
        messageKey: 'ARRIVAL_SCAN_TITLE',
        i18n_key: 'pda.prompt.title.arrival',
        popupType: PopupType.INTERCEPT,
    },
    SORTING_SCAN_TITLE: {
        messageKey: 'SORTING_SCAN_TITLE',
        i18n_key: 'pda.prompt.title.sorting',
        popupType: PopupType.INTERCEPT,
    },
    BAGGING_SCAN_TITLE: {
        messageKey: 'BAGGING_SCAN_TITLE',
        i18n_key: 'pda.prompt.title.bagging',
        popupType: PopupType.INTERCEPT,
    },
    BAG_MERGE_SCAN_TITLE: {
        messageKey: 'BAG_MERGE_SCAN_TITLE',
        i18n_key: 'pda.prompt.title.bagMerge',
        popupType: PopupType.INTERCEPT,
    },
    BAG_RESHIP_SCAN_TITLE: {
        messageKey: 'BAG_RESHIP_SCAN_TITLE',
        i18n_key: 'pda.prompt.title.bagReship',
        popupType: PopupType.INTERCEPT,
    },

    // ── 通用系统级错误 ───────────────────────────────────────────────────
    NETWORK_ERROR: {
        messageKey: 'NETWORK_ERROR',
        i18n_key: 'pda.prompt.errors.system.networkError',
        popupType: PopupType.NEED_ACTION,
    },

    // ── Arrival ─────────────────────────────────────────────────────────
    BLUETOOTH_NOT_CONNECTED: {
        messageKey: 'ARRIVAL_SCAN_TITLE',
        i18n_key: 'pda.prompt.pages.arrival.bluetoothNotConnected',
        popupType: PopupType.NEED_ACTION,
    },
    WEIGHT_NOT_AVAILABLE: {
        messageKey: 'ARRIVAL_SCAN_TITLE',
        i18n_key: 'pda.prompt.pages.arrival.weightNotAvailable',
        popupType: PopupType.NEED_ACTION,
    },
    NEGATIVE_WEIGHT: {
        messageKey: 'ARRIVAL_SCAN_TITLE',
        i18n_key: 'pda.prompt.pages.arrival.negativeWeightError',
        popupType: PopupType.NEED_ACTION,
    },

    // ── 通用条码校验 ─────────────────────────────────────────────────────
    INVALID_BAR_CODE: {
        messageKey: 'INVALID_BAR_CODE',
        i18n_key: 'pda.prompt.errors.invalidBarCode',
        popupType: PopupType.INTERCEPT,
    },
    INVALID_TRACKING_NUMBER: {
        messageKey: 'INVALID_BAR_CODE',
        i18n_key: 'pda.prompt.errors.invalidTrackingNumber',
        popupType: PopupType.INTERCEPT,
    },
    DUPLICATE_SCAN: {
        messageKey: 'ALREADY_SCANNED_TEMP',
        i18n_key: 'pda.prompt.arrival.scan.duplicateScan',
        popupType: PopupType.NOTICE,
    },

    // ── Sorting ──────────────────────────────────────────────────────────
    SORTING_DESTINATION_NOT_FOUND: {
        messageKey: 'BING_ERROR_AT_SORTING_SCAN',
        i18n_key: 'pda.prompt.pages.sorting.destinationNotFound',
        popupType: PopupType.NEED_ACTION,
    },
    SORTING_PLEASE_SELECT_DESTINATION: {
        messageKey: 'DESTINATION_WAREHOUSE_NOT_EXIST',
        i18n_key: 'pda.prompt.pages.sorting.pleaseSelectDestination',
        popupType: PopupType.NEED_ACTION,
    },

    // ── Bagging PDA ──────────────────────────────────────────────────────
    BAG_CODE_REQUIRED: {
        messageKey: 'BAGGING_BAG_CODE_REQUIRED',
        i18n_key: 'pda.prompt.common.bagCodeRequired',
        popupType: PopupType.NEED_ACTION,
    },

    // ── Bagging DSP ──────────────────────────────────────────────────────
    BAG_NOT_FOUND: {
        messageKey: 'BAG_NOT_EXIST',
        i18n_key: 'pda.prompt.pages.bagging.failedToGetBagDetail',
        popupType: PopupType.INTERCEPT,
    },
    BAG_SORTING_CODE_NOT_FOUND: {
        messageKey: 'BAG_NOT_EXIST',
        i18n_key: 'pda.prompt.pages.bagging.bagSortingCodeNotFound',
        popupType: PopupType.INTERCEPT,
    },
    BAGGING_ALREADY_SCANNED: {
        messageKey: 'PDA_BAGGING_ERROR_RELATED_BAG_IN_PROGRESS',
        i18n_key: 'pda.prompt.message.alreadyScanned',
        popupType: PopupType.NEED_ACTION,
    },
    BAGGING_DUPLICATE_SCAN: {
        messageKey: 'INVALID_BAR_CODE',
        i18n_key: 'pda.prompt.bagging.scan.duplicateScan',
        popupType: PopupType.INTERCEPT,
    },
    BAG_DISCARDED: {
        messageKey: 'BAG_NOT_AVAILABLE',
        i18n_key: 'pda.prompt.pages.bagging.bagDiscarded',
        popupType: PopupType.INTERCEPT,
    },
    BAG_HANDOVER: {
        messageKey: 'BAG_CLOSED',
        i18n_key: 'pda.prompt.pages.bagging.bagHandover',
        popupType: PopupType.INTERCEPT,
    },
    BAG_NOT_BELONG: {
        messageKey: 'BAG_NOT_BELONG_TO_CURRENT_WAREHOUSE',
        i18n_key: 'pda.prompt.errors.business.bag.notBelongToCurrentWarehouse',
        popupType: PopupType.INTERCEPT,
    },
    BAG_CARRIER_NOT_MATCH: {
        messageKey: 'CARRIER_BINDING_MISMATCH',
        i18n_key: 'pda.prompt.pages.bagging.bagCarrierNotMatch',
        popupType: PopupType.NEED_ACTION,
    },
    BAG_NO_MATCHING_DESTINATION: {
        messageKey: 'BAG_NO_MATCHING_DESTINATION',
        i18n_key: 'pda.prompt.pages.bagging.noMatchingDestination',
        popupType: PopupType.NEED_ACTION,
    },
    TT_BAG_NEXT_STOP_NOT_FOUND: {
        messageKey: 'BAG_NEXT_STOP_NOT_FOUND',
        i18n_key: 'pda.prompt.pages.bagging.ttBagNextStopNotFound',
        popupType: PopupType.INTERCEPT,
    },
    TT_BAG_NEXT_STOP_NOT_MATCH: {
        messageKey: 'BAG_NEXT_STOP_NOT_MATCH',
        i18n_key: 'pda.prompt.pages.bagging.ttBagNextStopNotMatch',
        popupType: PopupType.INTERCEPT,
    },
    BAG_SORTING_CODE_OVERLAP: {
        messageKey: 'BAG_SORTING_CODE_OVERLAP',
        i18n_key: 'pda.prompt.pages.bagging.bagSortingCodeOverlap',
        popupType: PopupType.INTERCEPT,
    },
    PLEASE_BIND_BAG_FIRST: {
        messageKey: 'BAGGING_BAG_CODE_REQUIRED',
        i18n_key: 'pda.prompt.common.pleaseBindBagCodeFirst',
        popupType: PopupType.NEED_ACTION,
    },
    NO_BAG_FOR_CARRIER: {
        messageKey: 'BAGGING_NO_BAG_FOR_SELECTED_CARRIER',
        i18n_key: 'pda.prompt.pages.bagging.noBagForSelectedCarrier',
        popupType: PopupType.INTERCEPT,
    },
    // PDA 新装包页更换容器：本地 state 缺 backendBagId（老数据/异常路径）
    // 仅 title 提示，不给 content —— i18n content 定义为空字符串，ScanResultPrompt 自动隐藏
    CHANGE_CONTAINER_NO_BAG_ID: {
        messageKey: 'BAGGING_CHANGE_CONTAINER_NO_BAG_ID',
        i18n_key: 'pda.prompt.pages.bagging.changeContainerNoBagId',
        popupType: PopupType.INTERCEPT,
    },
    // PDA 新装包页更换容器：mutation 返回 success=false 或抛异常
    // 后端 errorMessage 作为 content 占位注入；无 errorMessage 时 content 为空，仅展示 title
    CHANGE_CONTAINER_FAILED: {
        messageKey: 'BAGGING_CHANGE_CONTAINER_FAILED',
        i18n_key: 'pda.prompt.pages.bagging.changeContainerFailed',
        popupType: PopupType.INTERCEPT,
    },

    // ── BagMerge ─────────────────────────────────────────────────────────
    BAG_MERGE_SCAN_IN_PROGRESS: {
        messageKey: 'PDA_MERGE_ERROR_RELATED_BAG_IN_PROGRESS',
        i18n_key: 'pda.prompt.pages.bagMerge.scanInProgress',
        popupType: PopupType.NEED_ACTION,
    },
    BAG_MERGE_DUPLICATE_BAG: {
        messageKey: 'PDA_MERGE_ERROR_RELATED_BAG_IN_PROGRESS',
        i18n_key: 'pda.prompt.pages.bagMerge.duplicateBag',
        popupType: PopupType.NEED_ACTION,
    },
    BAG_MERGE_BAG_NOT_FOUND: {
        messageKey: 'BAG_NOT_EXIST',
        i18n_key: 'pda.prompt.pages.bagMerge.bagNotFound',
        popupType: PopupType.INTERCEPT,
    },
    BAG_MERGE_STATUS_NOT_USED: {
        messageKey: 'BAG_MERGE_STATUS_NOT_USED',
        i18n_key: 'pda.prompt.pages.bagMerge.statusNotUsed',
        popupType: PopupType.NEED_ACTION,
    },
    BAG_MERGE_EMPTY_BAG: {
        messageKey: 'BAG_MERGE_EMPTY_BAG',
        i18n_key: 'pda.prompt.pages.bagMerge.emptyBag',
        popupType: PopupType.NEED_ACTION,
    },
    BAG_MERGE_ALL_FINISHED: {
        messageKey: 'BAG_MERGE_BAG_ALL_FINISHED',
        i18n_key: 'pda.prompt.pages.bagMerge.bagAllFinished',
        popupType: PopupType.NEED_ACTION,
    },
    BAG_MERGE_BUSINESS_TYPE_MISSING: {
        messageKey: 'BAG_MERGE_BUSINESS_TYPE_MISSING',
        i18n_key: 'pda.prompt.pages.bagMerge.businessTypeMissing',
        popupType: PopupType.NEED_ACTION,
    },
    BAG_MERGE_BUSINESS_TYPE_MISMATCH: {
        messageKey: 'BAG_MERGE_BUSINESS_TYPE_MISMATCH',
        i18n_key: 'pda.prompt.pages.bagMerge.businessTypeMismatch',
        popupType: PopupType.NEED_ACTION,
    },
    BAG_MERGE_SORTING_CODE_MISMATCH: {
        messageKey: 'BAG_MERGE_SORTING_CODE_MISMATCH',
        i18n_key: 'pda.prompt.pages.bagMerge.sortingCodeMismatch',
        popupType: PopupType.NEED_ACTION,
    },
    BAG_MERGE_PRE_SORTING_CODE_MISMATCH: {
        messageKey: 'BAG_MERGE_PRE_SORTING_CODE_MISMATCH',
        i18n_key: 'pda.prompt.pages.bagMerge.preSortingCodeMismatch',
        popupType: PopupType.NEED_ACTION,
    },
    BAG_MERGE_TT_BIZ_TYPE_MISMATCH: {
        messageKey: 'BAG_MERGE_TT_BIZ_TYPE_MISMATCH',
        i18n_key: 'pda.prompt.pages.bagMerge.ttBizTypeMismatch',
        popupType: PopupType.NEED_ACTION,
    },
    // 选保留包时的方向性拒绝：与上面的「互斥无解」区分开——同一组包换选「不限」包作保留包就能合，
    // 说成"不一致"会误导工人以为这批包压根不能合
    BAG_MERGE_TT_BIZ_TYPE_TARGET_NOT_ALLOWED: {
        messageKey: 'BAG_MERGE_TT_BIZ_TYPE_TARGET_NOT_ALLOWED',
        i18n_key: 'pda.prompt.pages.bagMerge.ttBizTypeTargetNotAllowed',
        popupType: PopupType.NEED_ACTION,
    },
    BAG_MERGE_TOTAL_EXCEED_LIMIT: {
        messageKey: 'BAG_MERGE_TOTAL_EXCEED_LIMIT',
        i18n_key: 'pda.prompt.pages.bagMerge.totalExceedLimit',
        popupType: PopupType.NEED_ACTION,
    },
    BAG_MERGE_TARGET_NOT_IN_SOURCE: {
        messageKey: 'BAG_MERGE_TARGET_NOT_IN_SOURCE',
        i18n_key: 'pda.prompt.pages.bagMerge.targetNotInSource',
        popupType: PopupType.NEED_ACTION,
    },
    BAG_MERGE_INSUFFICIENT_BAGS: {
        messageKey: 'BAG_MERGE_INSUFFICIENT_BAGS',
        i18n_key: 'pda.prompt.pages.bagMerge.insufficientBags',
        popupType: PopupType.NEED_ACTION,
    },

    // ── Bag Reship（改流向）─────────────────────────────────────────────
    BAG_RESHIP_SELECT_REQUIRED: {
        messageKey: 'BAG_RESHIP_SELECT_REQUIRED',
        i18n_key: 'pda.prompt.pages.bagReship.selectRequired',
        popupType: PopupType.NEED_ACTION,
    },

} as const;
